export default __webpack_public_path__ + "static/media/uno-nosotros.a2d49ea0.webp";